<template>
  <div id="home" class="mainContainer">
    <header>
      <headerIndex />
      <div class="reactive">
        <DateChange ref="dateChange" @change="handlerDateChange" />
      </div>
      <div class="flex flex-between pl10 pr10">
        <div class="gray-2">营业额</div>
        <div class="fs26">{{ totalRetailAmount }}</div>
      </div>
    </header>
    <div class="bg-white">
      <van-grid square :column-num="3">
        <van-grid-item v-for="item in metricCards" :key="item.key">
          <div class="fb fs14 gray-7">{{ item.label }}</div>
          <div class="fb">{{ item.display }}</div>
        </van-grid-item>
      </van-grid>
    </div>
    <div class="m15 bg-white">
      <div class="content">
        <div class="title">常用应用</div>
        <van-row type="flex" justify="space-around">
          <van-col
            span="6"
            class="item flex flex-column"
            @click="goTo('/product/category', { type: 'edit' })"
          >
            <div class="item2">
              <van-icon name="gift-o"></van-icon>
              <div class="fs12 gray-8">商品档案</div>
            </div>
          </van-col>
          <van-col
            span="6"
            class="item flex flex-column"
            @click="goTo('/product/category', { type: 'search' })"
          >
            <div class="item2">
              <van-icon name="gift-o"></van-icon>
              <div class="fs12 gray-8">商品查询</div>
            </div>
          </van-col>
          <van-col
            span="6"
            class="item flex flex-column"
            @click="goTo('/purchase/order')"
          >
            <div class="item2">
              <van-icon name="gift-o"></van-icon>
              <div class="fs12 gray-8">采购订单</div>
            </div>
          </van-col>
          <van-col
            span="6"
            class="item flex flex-column"
            @click="goTo('/purchase/return')"
          >
            <div class="item2">
              <van-icon name="gift-o"></van-icon>
              <div class="fs12 gray-8">采购退货</div>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="m15 bg-white">
      <div class="content">
        <div class="title">常用数据</div>
        <van-row type="flex" justify="space-start">
          <van-col
            span="6"
            class="item flex flex-column"
            @click="goTo('/analysis')"
          >
            <div class="item2">
              <van-icon name="gift-o"></van-icon>
              <div class="fs12 gray-8">商品分析</div>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
import DateChange from "../../components/dateChange.vue";
import headerIndex from "../header/index.vue";
import { getFinancialAnalysis } from "../../service/api/home";
import { preciseMultiplication } from "../../utils/index.js";
export default {
  name: "HomeNew",
  components: { DateChange, headerIndex },
  data() {
    return {
      totalRetailAmount: 0,
      metricCards: [],
      params: {
        startDate: "",
        endDate: "",
      },
    };
  },
  mounted() {
    this.params.startDate = this.$refs.dateChange.formattedStartDate;
    this.params.endDate = this.$refs.dateChange.formattedEndDate;
    this.fetchFinancialAnalysis();
  },
  methods: {
    goTo(target, params) {
      this.$router.push({ path: target, query: params });
    },
    handlerDateChange(startDate, endDate) {
      this.params = { ...this.params, startDate, endDate };
      this.fetchFinancialAnalysis();
    },
    toDateTimeStart(date) {
      if (!date) {
        return "";
      }
      return String(date).includes(" ") ? date : `${date} 00:00:00`;
    },
    toDateTimeEnd(date) {
      if (!date) {
        return "";
      }
      return String(date).includes(" ") ? date : `${date} 23:59:59`;
    },
    formatMetric(val) {
      if (val == null || val === "") {
        return 0;
      }
      return val;
    },
    formatPercent(val) {
      if (val == null || val === "") {
        return "0%";
      }
      const text = String(preciseMultiplication(val, 100));
      return text.endsWith("%") ? text : `${text}%`;
    },
    // 只映射经营总览字段，不展开营业明细，也不回写未知字段
    applyFinancialAnalysis(data) {
      const d = data || {};
      this.totalRetailAmount = this.formatMetric(d.operatingRevenue);
      this.metricCards = [
        {
          key: "operatingRevenue",
          label: "营业收入",
          display: this.formatMetric(d.operatingRevenue),
        },
        {
          key: "netOperatingRevenue",
          label: "实际收入",
          display: this.formatMetric(d.netOperatingRevenue),
        },
        {
          key: "customerOrderCount",
          label: "客单数",
          display: this.formatMetric(d.customerOrderCount),
        },
        {
          key: "costAmount",
          label: "成本总金额",
          display: this.formatMetric(d.costAmount),
        },
        {
          key: "grossProfit",
          label: "毛利",
          display: this.formatMetric(d.grossProfit),
        },
        {
          key: "grossMarginRate",
          label: "毛利率",
          display: this.formatPercent(d.grossProfitMargin),
        },
      ];
    },
    fetchFinancialAnalysis() {
      if (!this.params.startDate || !this.params.endDate) {
        return;
      }
      // 不传 merchId，由后端按登录态取当前门店，避免客户端伪造查询范围
      getFinancialAnalysis({
        start: this.toDateTimeStart(this.params.startDate),
        end: this.toDateTimeEnd(this.params.endDate),
      })
        .then((res) => {
          this.applyFinancialAnalysis(res && res.data);
        })
        .catch((e) => {
          console.warn("获取财务分析数据失败，保留当前展示", e);
        });
    },
  },
};
</script>

<style lang="less" scoped>
#home {
  padding-bottom: 50px;
}
header {
  padding: 20px 10px 10px;
}

.content {
  padding: 15px;
  .title {
    padding: 5px 0;
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  .item2 {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
    color: #333;
  }
  .van-icon {
    font-size: 20px;
    color: #777;
  }
}
</style>
